<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">I would like to dedicate this book to:</p>
<br/><p style="text-indent:00em;">Afrodita Katmeridou – My piano teacher for whom I’ve used her surname as the title.</p>
<br/><p style="text-indent:00em;">Sebastian Hawker – My only genuine friend in school.</p>
<br/><p style="text-indent:00em;">My two sisters, Ketaki and Kasturi – For which this book might show a different side of me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?36cf70b6